import {Store} from "@bryntum/schedulerpro";
import {ReminderRecipient} from "../../models/ReminderRecipient.jsx";
import { STORE_KEYS } from "../../../other/constants/StoreKeys.jsx";

export class ReminderRecipientStore extends Store {
  static get $name() {
    return "ReminderRecipientStore";
  }

  static get configurable() {
    return {
      id: STORE_KEYS.reminderRecipientStore,
      storeId: STORE_KEYS.reminderRecipientStore,
      modelClass: ReminderRecipient,
    };
  }
}
